const TenantClientList_query = `
    query
    {
      tenantClientList
      {
          clientId
          clientUuid
          tenantId
          {
            tenantId
            name            
          }
          name
          defaultClient
          termStartDate
          termNoOfWeeks
          createDate
          updateDate
          deleteMessage
          groupsList
          {
            groupId
            name
          }
      }
    }
`;

const StaffClientList_query = `
    query( $username: String!)
    {
      staffClientList(username:$username)
      {
          client{
            clientId
            clientUuid
            name
            termStartDate
            termNoOfWeeks
          }
          groups
          {
            groupId
            name
            groupUuid
          }
      }
    }
`;


const StaffClientListWithTerms_query = `
    query( $username: String!, $tenantId: Int!)
    {
      staffClientListWithTerms(username:$username, tenantId:$tenantId)
      {
        clientId
        clientUuid
        name
        termStartDate
        termNoOfWeeks
      }
    }
`;

const CreateClient_mutate = `
    mutation createClient(
      $name: String!
      $tenantId: Int!
      $termStartDate: String
      $termNoOfWeeks: Int      
      ) {
      createClient(
        name: $name,
        tenantId: $tenantId
        termStartDate: $termStartDate
        termNoOfWeeks: $termNoOfWeeks) {
        client
          {
            clientId
            clientUuid
            name
            termStartDate
            termNoOfWeeks
            tenantId            
            {
              name
            }
            createBy
            createDate
            updateBy
            updateDate
          }
      }
    }
`;

const EditClient_mutate = `
    mutation editClient(      
      $name: String!
      $clientUuid: String!
      $termStartDate: String
      $termNoOfWeeks: Int      
      ) {
      editClient(        
        name: $name,
        clientUuid: $clientUuid
        termStartDate: $termStartDate
        termNoOfWeeks: $termNoOfWeeks) {
        client
          {
            clientId
            clientUuid
            tenantId
            {
              name
            }
            termStartDate
            termNoOfWeeks
            createBy
            createDate
            updateBy
            updateDate
          }
      }
    }
`;

const UpdateClientTermsConfigure_mutate = `
    mutation updateClientTermsConfigure(            
      $clientId: Int!      
      $noOfWeeks: Int!
      $startDate: String!
      ) {
      updateClientTermsConfigure(                
        clientId: $clientId,
        noOfWeeks: $noOfWeeks,
        startDate: $startDate
        ) {
        client
          {
            clientId
            termNoOfWeeks
            termStartDate
            tenantId
            {
              name
            }
            createBy
            createDate
            updateBy
            updateDate
          }
      }
    }
`;

const GetClientDataByName_query = `
    query( $name: String! , $tenantId: Int! , $clientUuid: String)
    {
      getClientDataByName(name:$name,tenantId:$tenantId,clientUuid:$clientUuid)
      {
          clientId
          clientUuid
          name
          termNoOfWeeks
          termStartDate
          tenantId
            {
              name
            }
          createBy
          createDate
          updateBy
          updateDate
      }
    }
`;

const GetClientDataByID_query = `
    query( $clientUuid: String!)
    {
      getClientDataByID(clientUuid:$clientUuid)
      {
          clientId
          clientUuid
          tenantId
            {
              name
             contactEmail 
            }
          name
          termNoOfWeeks
          termStartDate
          createBy
          createDate
          updateBy
          updateDate
      }
    }
`;

const DeleteClient_mutate = `
    mutation delete_client($clientUuid: String!) {
      deleteClient(clientUuid: $clientUuid) {
        response
      }
    }
`;

const GetFormInfoByClientUuid_query = `
  query( $clientUuid: String!)
  {
    getFormInfoByClientUuid(clientUuid: $clientUuid)
    {
      term
      {
          termId
          termUuid
          formId{
            formId 
            formUuid
            name
            createDate
            approved
            termList
            clientId {
              clientId
              name
              tenantId {
                tenantId
                name
                contactEmail
                statesList{
                  id 
                  name 
                  code
                }
                countriesList{
                  id 
                  name 
                  code
                }
              }
            }
          }
          name
          startDate
          endDate
          urlActivated
          noOfSeats
      }
      message  
      form{
        formUuid
        formId
      }
      period
      {
        startDate
      }      
    }
  }    
`;

const GetClientUuid = `query getClientData($clientId: Int!){
  getClientData(clientId: $clientId){
      clientId
      clientUuid
      tenantId
        {
          name
          contactEmail 
        }
      name
      termNoOfWeeks
      termStartDate
      createBy
      createDate
      updateBy
      updateDate
  }
}`;

const SetDefaultClient_mutate = `
    mutation setDefaultClient($clientId: Int!) {
      setDefaultClient(clientId: $clientId) {
        client
          {
            clientId
            name
            clientUuid
            tenantId
            {
              name
            }
            
          }
      }
    }
`;

module.exports = {
  TENANT_CLIENT_LIST_QUERY: TenantClientList_query,
  STAFF_CLIENT_LIST_QUERY: StaffClientList_query,
  STAFF_CLIENT_LIST_WITH_TERMS_QUERY: StaffClientListWithTerms_query,
  CREATE_CLIENT_MUTATION: CreateClient_mutate,
  EDIT_CLIENT_MUTATION: EditClient_mutate,
  UPDATE_CLIENT_TERMS_CONFIGURE_MUTAION: UpdateClientTermsConfigure_mutate,
  GET_CLIENT_DATA_BY_NAME: GetClientDataByName_query,
  GET_CLIENT_DATA_BY_ID: GetClientDataByID_query,
  DELETE_CLIENT_MUTATION: DeleteClient_mutate,
  GET_FORM_INFO_BY_CLIENT_UUID: GetFormInfoByClientUuid_query,
  GET_CLIENT_UUID: GetClientUuid,
  SET_DEFAULT_CLIENT_MUTATION: SetDefaultClient_mutate,
};
